import { AfterViewInit, Component, EventEmitter, OnDestroy, Input } from '@angular/core';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { finalize, filter } from 'rxjs/operators';
import { AssistedSelfServiceInvitation } from './models/assisted-self-service-invitation.model';
import { Subscription } from 'rxjs';
import { MVDNowViewService } from '../mvdnow-view.service';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { ModalSize } from '../../../shared/services/modal/mvd-modal.enum';
import { AssistedSelfServiceInvitationContext, AssistedSelfServiceInvitationModalComponent } from '../../../shared/components/assisted-self-service-invitation/assisted-self-service-invitation-modal.component';
import { AssistedSelfServiceInvitationService } from '../../../shared/services/assisted-self-service-invitation/assisted-self-service-invitation.service';
import { SharedAlertData } from '../../../shared/components/modals/alert-data.model';
import { AssistedSelfServiceType } from '../../../shared/enums/assisted-self-service-invitation/assisted-self-service-type.enum';

@Component({
    selector: 'assisted-self-service-invitation-list',
    templateUrl: './assisted-self-service-invitation-list.html',
})

export class AssistedSelfServiceInvitationComponent extends BaseComponent implements OnDestroy {
    public loaded = false;
    public invitations: AssistedSelfServiceInvitation[];
    public types: AssistedSelfServiceType = new AssistedSelfServiceType();
    private customerNumber: number;
    private viewServiceSubscription: Subscription;

    constructor(public service: AssistedSelfServiceInvitationService, public viewService: MVDNowViewService, public modalService: MvdModalService) {
        super();
    }

    ngOnInit() {
        this.viewServiceSubscription = this.viewService.customerNumberSubject.subscribe(
            async customerNumber => {
                this.customerNumber = customerNumber;
                if (customerNumber) {
                    this.getInvitations();
                }
            }
        );
    }

    getInvitations() {
        this.service.getCustomerAssistedSelfServiceInvitations(this.customerNumber).pipe(
            finalize(() => {
                this.loaded = true;
            }))
            .subscribe(
                (data) => {
                    this.invitations = data;
                },
                (error) => {
                    this.handleValidationResult(error);
                });
    }

    ngOnDestroy() {
        if (this.viewServiceSubscription) {
            this.viewServiceSubscription.unsubscribe();
            this.viewServiceSubscription = null;
        }

        super.ngOnDestroy();
    }

    createInvitation() {
        this.service.isCustomerDeceased(this.customerNumber)
            .subscribe(
                (response) => {
                    if (response) {
                        const data = new SharedAlertData();
                        data.body('You have selected an invalid customer, customer reported deceased.');
                        this.modalService.alertModal(data);
                    } else {
                        const data = new AssistedSelfServiceInvitationContext(this.customerNumber);
                        this.modalService.open(AssistedSelfServiceInvitationModalComponent, data, ModalSize.Medium).afterClosed()
                            .pipe(filter(result => !!result))
                            .subscribe(
                                () => {
                                    this.getInvitations();
                                }
                            );
                    }
                }
            );
    }

    expireInvitation(invitation: AssistedSelfServiceInvitation) {
        invitation.expired = true;
        this.service.expireAssistedSelfServiceInvitation(invitation.id)
            .subscribe(
                () => {
                    this.getInvitations();
                },
                (error) => {
                    this.handleValidationResult(error);
                    invitation.expired = false;
                });
    }

    printInvitation(invitation: AssistedSelfServiceInvitation) {
        const printWindow = window.open('', 'PRINT');

        printWindow.document.write('<html><body>');
        printWindow.document.write(`<h1>${this.types.FromId(invitation.assistedSelfServiceTypeId).displayValue}</h1>`);
        printWindow.document.write(`<div><b>Invitation Code:</b> ${invitation.token}</div>`);
        printWindow.document.write(`<div><b>PIN:</b> ${invitation.pin}</div>`);
        printWindow.document.write('</body></html>');

        printWindow.document.close();
        printWindow.focus();

        printWindow.print();
        printWindow.close();
    }
}
